export const PARAMETRO_ALL = 'PARAMETRO_ALL';
export const PARAMETRO_ALL_START = 'PARAMETRO_ALL_START';
export const PARAMETRO_ALL_SUCCESS = 'PARAMETRO_ALL_SUCCESS';
export const PARAMETRO_ALL_ERROR = 'PARAMETRO_ALL_ERROR';
